// extracted by mini-css-extract-plugin
export var collapsedSummary = "_nz-0";